import { useRef } from "react";

function useFocus() {
  const htmlElRef = useRef<any>(null);
  const setFocus = () => {
    console.log(htmlElRef.current);
    setTimeout(() => {
      if (htmlElRef.current) {
        htmlElRef.current.select();
        htmlElRef.current.focus();
      }
    }, 0);
  };

  return [htmlElRef, setFocus];
}
export default useFocus;
